// extracted by mini-css-extract-plugin
export default {"item":"Rating_item__Z7kr1","rocket":"Rating_rocket__S6J3G"};